const VEHICLE_BODY_DEFINITIONS = [
    { id: "panel_van", value: "Panel van", label: "Panel van", sortOrder: 10.0000, inherentCapabilities: [] },
    { id: "box", value: "Box", label: "Box", sortOrder: 20.0000, inherentCapabilities: [] },
    { id: "curtainsider", value: "Curtainsider", label: "Curtainsider", sortOrder: 30.0000, inherentCapabilities: [] },
    { id: "refrigerated", value: "Refrigerated", label: "Refrigerated", sortOrder: 40.0000, inherentCapabilities: ["temperature_controlled"] },
    { id: "flatbed", value: "Flatbed", label: "Flatbed", sortOrder: 50.0000, inherentCapabilities: [] },
    { id: "dropside", value: "Dropside", label: "Dropside", sortOrder: 60.0000, inherentCapabilities: [] },
    { id: "beavertail", value: "Beavertail", label: "Beavertail", sortOrder: 65.0000, inherentCapabilities: ["loading_ramps"] },
    { id: "car_transporter", value: "Car transporter", label: "Car transporter", sortOrder: 70.0000, inherentCapabilities: [] },
    { id: "low_loader", value: "Low-loader", label: "Low-loader", sortOrder: 80.0000, inherentCapabilities: [] },
    { id: "skeletal_container", value: "Skeletal/container", label: "Skeletal/container", sortOrder: 90.0000, inherentCapabilities: [] },
    { id: "tanker", value: "Tanker", label: "Tanker", sortOrder: 100.0000, inherentCapabilities: [] },
    { id: "other", value: "Other", label: "Other", sortOrder: 999.0000, inherentCapabilities: [] }
];
export const VEHICLE_BODY_TYPES = [...VEHICLE_BODY_DEFINITIONS].sort((left, right) => left.sortOrder - right.sortOrder);
export function vehicleBodyDefinition(value) {
    return VEHICLE_BODY_TYPES.find(body => body.value === value);
}
export function vehicleHasCapability(bodyType, capabilities, capabilityId) {
    return Boolean(capabilities[capabilityId]) || Boolean(vehicleBodyDefinition(bodyType)?.inherentCapabilities.includes(capabilityId));
}
export function missingVehicleCapabilities(requirements, bodyType, capabilities, level) {
    return Object.entries(requirements)
        .filter(([capabilityId, requirement]) => requirement === level && !vehicleHasCapability(bodyType, capabilities, capabilityId))
        .map(([capabilityId]) => capabilityId);
}
